import React from 'react';
import { useTranslation } from 'react-i18next';
import './LegalPage.css';

export default function TokushohoPage() {
    const { t } = useTranslation();

    const rows = [
        { label: t('tokushoho.seller'), value: t('company.legalName') },
        { label: t('tokushoho.serviceName'), value: t('company.serviceName') },
        { label: t('tokushoho.representative'), value: t('company.representative') },
        { label: t('tokushoho.address'), value: t('company.address') },
        { label: t('tokushoho.phone'), value: t('company.phone') },
        { label: t('tokushoho.email'), value: t('company.email') },
        { label: t('tokushoho.website'), value: t('company.website') },
        { label: t('tokushoho.price'), value: t('tokushoho.priceValue') },
        { label: t('tokushoho.otherFees'), value: t('tokushoho.otherFeesValue') },
        { label: t('tokushoho.paymentMethods'), value: t('tokushoho.paymentMethodsValue') },
        { label: t('tokushoho.paymentTiming'), value: t('tokushoho.paymentTimingValue') },
        { label: t('tokushoho.delivery'), value: t('tokushoho.deliveryValue') },
        { label: t('tokushoho.returnsDefective'), value: t('tokushoho.returnsDefectiveValue') },
        { label: t('tokushoho.returnsCustomer'), value: t('tokushoho.returnsCustomerValue') },
        { label: t('tokushoho.restrictions'), value: t('tokushoho.restrictionsValue') },
    ];

    const subtitle = t('tokushoho.subtitle');

    return (
        <div className="legal-page">
            <h1>{t('tokushoho.title')}</h1>
            {subtitle && <p className="legal-subtitle">{subtitle}</p>}
            <table className="legal-table">
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.label}>
                            <th>{row.label}</th>
                            <td>{row.value}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
